import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Container } from '../../components/layout/style';
import {getBatchDetails,fileDownloader} from '../../actions/batch';
import { Table, Tag, Space, PageHeader, Modal, Button, Input, Row, Col, Select, Tooltip, Descriptions, Spin, Card } from 'antd';
import { CheckCircleFilled, CloseCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import './style.css'
const BatchDetails =  ({location,getBatchDetails,fileDownloader}) => {
    const [data, setData] = useState([])
    const [id, setId] = useState(false)
    const [isThumbVisible, setisThumbVisible] = useState(false)
    useEffect( async () => {
        window.scrollTo(0, 0);
        const search = location.search;
        const id = new URLSearchParams(search).get("id");
        setId(id)
        const res = await getBatchDetails(id);
        setData(res)
    }, [])


    const makeLocalTime = (date) => {
      let mainDate = date.split('T')[0];
      let hours = date.split('T')[1].split(':')[0];
      let minutes = date.split('T')[1].split(':')[1];
      var am = true;
      if (hours > 12) {
          am = false;
          hours -= 12
      } else if (hours == 12) {
          am = false;
      } else if (hours == 0) {
          hours = 12
      }
      return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
    }
    return ( 
        <Container style={{minHeight: '100vh'}}>
        <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Batch"
            subTitle="Batch details"
            
        >
        </PageHeader>
        <div className='wrapper'>
            
            <h2>Batch No : {data?.batch_no}</h2>
            {data?.payment_status === 'paid' ? <Tag color="#2db7f5">{data?.payment_status}</Tag> : null}
            {data?.payment_status === 'unpaid' ? <Tag color="#be3636">{data?.payment_status}</Tag> : null}
            {data?.active === 'active' ? <Tag color="#2db7f5">{data?.active}</Tag> : null}
            {data?.active === 'inactive' ? <Tag color="#be3636">{data?.active}</Tag> : null}
           
            <Tag color="#cd2df5">{data?.created_at ? makeLocalTime(data?.created_at) : null}</Tag>
            {data.status == 'processed' ? 
                                <Button size="small" style={{float:'right'}} type="primary" icon={<DownloadOutlined  />} onClick={() => fileDownloader(data.batch_id)}>Download Code</Button> 
                                :
                                <Button size="small" style={{float:'right'}} type="default" icon={<Spin size='small' />} style={{cursor: "not-allowed"}}> &nbsp; Processing</Button>
                            }
            <br />
            <br />
            <br />
       
      
            {/* <Row className='detailContainer'gutter={16}>
                <Col xs={0} sm={2}></Col>

                <Col xs={24} sm={10} className='big-image-container'>
                    <Row >
                        <Col xs={24}>
                            <h1>Batch Information</h1>
                            <h4 style={{fontWeight: 'bold'}}>Batch Title</h4>
                            <p style={{fontSize: '14px', color: 'gray'}}>{data?.title}</p>
                            <br />
                            <h4 style={{fontWeight: 'bold'}}>Total Code</h4>
                            <Button style={{fontSize: '14px', color: 'gray'}}>{data?.code_count}</Button>
                            <br />
                            <br />
                        </Col>
                        <Col xs={24}>
                            <h4 style={{fontWeight: 'bold'}}>Code Type: &nbsp;
                            {data?.code_type === 'qrcode' ?
                                <>
                                    <Tag type="primary" style={{boxShadow: '0px 4px 13px -3px #00000047'}} >  QR Code</Tag>
                                </> :
                                <>
                                    <Tag type="primary" style={{boxShadow: '0px 4px 13px -3px #00000047'}} > Barcode</Tag>
                                </> 
                            }
                            </h4>

                            <h4 style={{fontWeight: 'bold'}}>Duribility: &nbsp;
                                {data?.life_time === 'expireable' ?
                                    <>
                                        <Tag type="primary" style={{boxShadow: '0px 4px 13px -3px #00000047'}} >Expireable</Tag>
                                    </> :
                                    <>
                                        <Tag type="primary" style={{boxShadow: '0px 4px 13px -3px #00000047'}} >Non Expireable</Tag>
                                    </> 
                                }
                            </h4>
                            
                            <h4 style={{fontWeight: 'bold'}}>More Information:</h4>
                            <Row gutter={18}>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>Manufacture Date</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}>{data?.manufacture_date ? makeLocalTime(data?.manufacture_date) : null}</p>
                                    </Card>
                                </Col>
                                
                                <Col xs={24} sm={0}>&nbsp;</Col>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>Expiry Date</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}>{data?.expire_date ? makeLocalTime(data?.expire_date) : 'Non expi'}</p>
                                    </Card>
                                </Col>
                                
                                <Col xs={24} sm={24}>&nbsp;</Col>

                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>Cost</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong> Unit cost:</strong> {data?.unit_cost}</p>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong> Total cost:</strong> {data?.price}</p>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong> Currency:</strong> {data?.currency}</p>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={24}>&nbsp;</Col>

                        <Col xs={18}>
                            <h4 style={{fontWeight: 'bold'}}>More Information:</h4>
                            <Row gutter={30}>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>WEIGHT</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}><strong>Weight:</strong> {data?.weight}</p>
                                        <p style={{fontSize: '14px', color: 'gray'}}><strong>Weight unit:</strong> {data?.weight_unit}</p>
                                    </Card>
                                </Col>
                                
                                <Col xs={24} sm={0}>&nbsp;</Col>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>Price</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}><strong>Price:</strong> {data?.price}</p>
                                        <p style={{fontSize: '14px', color: 'gray'}}><strong>Currency:</strong> {data?.currency}</p>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </Col>

                <Col xs={0} sm={1}>&nbsp;</Col>
                
                <Col xs={24} sm={10}>
                    <Row >
                        <Col xs={12} style={{textAlign: 'center'}} >
                            {data?.product?.image ? <img  width="125px" height="125px" src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.product.image}`} alt="Product Thumbnail" />
                            :null}
                            <br />
                            
                        </Col>
                        
                        <Col xs={24}>
                            <h1>Product Information</h1>
                            <h4 style={{fontWeight: 'bold'}}>{data?.name}</h4>
                            <p style={{fontSize: '14px', color: 'gray'}}>{data?.description}</p>
                        </Col>
                        <Col xs={24}>
                            <h4 style={{fontWeight: 'bold'}}>Status:</h4>
                            {data?.active === 'active' ?
                                <>
                                    <Tag type="primary" style={{boxShadow: '0px 4px 13px -3px #00000047'}} >Active</Tag>
                                </> :
                                <>
                                    <Tag type="primary" style={{boxShadow: '0px 4px 13px -3px #00000047'}} >Done</Tag>
                                </> 
                            }
                        </Col>
                        <Col xs={24}>&nbsp;</Col>

                        <Col xs={18}>
                            <h4 style={{fontWeight: 'bold'}}>More Information:</h4>
                            <Row gutter={30}>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>Weight</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong>Weight:</strong> {data?.weight}</p>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong>Weight unit:</strong> {data?.weight_unit}</p>
                                    </Card>
                                </Col>
                                
                                <Col xs={24} sm={0}>&nbsp;</Col>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold'}}>Price</h4>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong>Price:</strong> {data?.price}</p>
                                        <p style={{fontSize: '14px', color: 'gray'}}> <strong>Currency:</strong> {data?.currency}</p>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </Col>

                <Col xs={0} sm={1}></Col>

            </Row>
 */}







        <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
            <h2 style={{display: 'inline-block', borderBottom: '2px solid red', padding: ' 0px 20px'}}>Batch Information</h2>
            <br />
            <br />
            <Descriptions>
                <Descriptions.Item label="Title"><strong>{data?.title}</strong></Descriptions.Item>
                <Descriptions.Item label="Code type"><strong>{data?.code_type === 'qrcode' ? 'QR Code' : 'Barcode'}</strong></Descriptions.Item>
                <Descriptions.Item label="Total code"><strong>{data?.code_count}</strong></Descriptions.Item>
                <Descriptions.Item label="Unit cost"><strong>{data?.unit_cost}</strong></Descriptions.Item>
                <Descriptions.Item label="Total cost"><strong>{data?.total_cost}</strong></Descriptions.Item>
                <Descriptions.Item label="Duribility"><strong>{data?.life_time === 'expireable' ? 'Expirable' : 'Non-Expiring'}</strong></Descriptions.Item>
                <Descriptions.Item label="Manufacture Date"><strong>{data?.manufacture_date ? makeLocalTime(data?.manufacture_date) : null}</strong></Descriptions.Item>
                {data?.expire_date ? <Descriptions.Item label="Expiry Date"><strong>{data?.expire_date ? makeLocalTime(data?.expire_date) : null}</strong></Descriptions.Item> : null}
                <Descriptions.Item label="Currency"><strong>{data?.currency}</strong></Descriptions.Item>
                {/* <Descriptions.Item label="File">
                {data.status == 'processed' ? 
                <Button size="small" type="primary" icon={<DownloadOutlined  />} onClick={() => this.props.fileDownloader(data.batch_id)}>Download</Button> 
                :
                <Button size="small" type="default" icon={<Spin size='small' />} style={{cursor: "not-allowed"}}> &nbsp; Processing</Button>
            }
                </Descriptions.Item> */}
            </Descriptions>
        </Card>
        <br />
        <br />
        
        <Card style={{boxShadow: '0px 4px 13px -3px rgba(0,0,0,0.62)', borderRadius: '8px'}}>
            <h2  style={{display: 'inline-block', borderBottom: '2px solid red', padding: ' 0px 20px'}}>Product Information</h2>
            
       <Row style={{display: 'flex', justifyContent:'center'}}>
          

           
            <Col xs={24} md={24}  style={{alignSelf: 'center',display: 'flex', justifyContent:'center', flexDirection: 'column'}}>
                {data?.product?.image ? 
                <img width="100px" height="100px" src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.product.image}`} alt="" style={{alignSelf: 'center'}} />
                :
                <img width="100px" height="100px" src='demo.jpg' alt="" style={{alignSelf: 'center'}}  />
                }
                
            </Col>

            
           <Col xs={0} md={8} style={{alignSelf: 'center'}}></Col>
       </Row>
            <Descriptions>
                <Descriptions.Item label="Name"><strong>{data?.product?.name}</strong></Descriptions.Item>
                <Descriptions.Item label="Status"><strong>{data?.product?.active}</strong></Descriptions.Item>
                <Descriptions.Item label="Price"><strong>{data?.price}</strong></Descriptions.Item>
                <Descriptions.Item label="Currency"><strong>{data?.currency}</strong></Descriptions.Item>
                <Descriptions.Item label="Description"><strong>{data?.description}</strong></Descriptions.Item>
            </Descriptions>
        </Card>
        <br />
        <br />
       
       </div>
       
      
        </Container>
     );
}
 
export default connect(null, {getBatchDetails,fileDownloader})(BatchDetails);